import { NgModule, ModuleWithProviders } from '@angular/core';
import { LoginDataAccessLoginModule } from '@gaia/gaia/login/data-access-login';
import { EffectsModule } from '@ngrx/effects';
import { AuthEventsEffects } from './events/auth.events.effects';
@NgModule({
    imports: [EffectsModule.forFeature([AuthEventsEffects]), LoginDataAccessLoginModule],
})
export class AuthModule {
    static forRoot(): ModuleWithProviders<AuthModule> {
        return {
            ngModule: AuthModule,
        };
    }
}
